<template>
  <div class="wrapper" id="wrapper-div">
    <div id="project_amount_params">
      <div id="project_amount_selects">
        <div class="project_amount_select">
          <input type="radio" id="1" value="COMPANY" v-model="optionSearch"/>
          <label for="1">Công ty</label>
        </div>
        <div class="project_amount_select">
          <input type="radio" id="2" value="SOFTWARE_DEVELOPMENT" v-model="optionSearch"/>
          <label for="2">Khối PT1</label>
        </div>
        <div class="project_amount_select">
          <input type="radio" id="3" value="SOFTWARE_DEVELOPMENT_2" v-model="optionSearch"/>
          <label for="3">Khối PT2</label>
        </div>
      </div>
      <div id="year_select">
        <select v-model="search.year" @change="changeYear()">
          <option v-for="year in listYear" :value="year">{{ year }}</option>
        </select>
      </div>
    </div>
    <div class="wrapper-chart" id="zoom-chart">
      <div style="width: 90%" @wheel.prevent="zoomIn">
        <v-chart
          :option="option"
          autoresize
          style="min-height: 500px;width: 100%;"
          @resize="resizeWidth"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {use} from "echarts/core";
import {CanvasRenderer} from "echarts/renderers";
import { BarChart  } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  ToolboxComponent,
  DataZoomComponent
} from "echarts/components";
import VChart from "vue-echarts";
use([
  CanvasRenderer,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  TimelineComponent,
  GridComponent,
  ToolboxComponent,
  DataZoomComponent,
  BarChart
]);
import {mapGetters} from "vuex";
import {TimelineComponent} from 'echarts/components';
import moment from "moment";

const colors = ['#01959E', '#EA6057', '#555D6C'];
const labels = ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'];
export default {
  name: "ResourceDivision",
  props: {
    division: String,
    title: String
  },
  components: {
    VChart
  },
  data() {
    return {
      option: {
        barWidth: 50,
        color: colors,
        grid: {
          left: '4%',
          right: '0'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
          },
          borderWidth: 5,
          padding: 0,
          // backgroundColor: 'transparent',
          textStyle: {
            fontFamily: 'Helvetica',
            fontSize: 16,
          },
        //   formatter: (params) => {
        //     const details = params[0]['data']['detail'];
        //     console.log(params[0]['data'], 'test');
        //     let string = `<div
        //                   <div style="background: #E0E0E0;font-family: 'Helvetica Neue';font-style: normal;font-weight: 500;font-size: 14px;line-height: 17px;color: #303C54;border-radius: 10px 10px 0 0;height: 39px;display: flex;justify-content:center;align-items: center">
        //                     Tháng ${parseInt(params[0]['data']['name'])}
        //                   </div>
        //                   <div style="padding: 14px 10px 14px 10px;border: 1px solid #ECECEC;border-radius: 0 0 10px 10px;background: #FFFFFF;">
        //                     <div style="border: 1px solid #ECECEC;border-radius: 10px;">
        //                     `
        //     let i = 0;
        //     Object.keys(details).forEach(key => {
        //       console.log( 'key', key);
        //       if (i < 5) {
        //         string += `<div >
        //                         <table>
        //                           <thead>
        //                             <th style="width: 60%"></th>
        //                             <th style="width: 40%"></th>
        //                           </thead>
        //                           <tbody>
        //                           <tr>
        //                             <td style="padding: 6px 0 6px 10px; flex: 1; border-right: 1px solid #ECECEC; border-bottom: ${i !== details.length - 1 ? '1px solid #ECECEC' : 'none'};
        //                                 font-family: Helvetica Neue; font-style: normal;font-weight: 400;font-size: 14px;line-height: 17px;">${key}</td>
        //                             <td style="padding: 6px 10px 6px 0; flex: 1; border-bottom: ${i !== details.length - 1 ? '1px solid #ECECEC' : 'none'};
        //                                 text-align: end; color: #17A896;font-family: Helvetica Neue; font-style: normal;
        //                                 font-weight: 700;font-size: 14px; line-height: 17px; width: 100px;">${details[key]}MM</td>
        //                           </tr>
        //                           </tbody>
        //                         </table>
        //                     </div>`
        //       }
        //       i ++;
        //     });
        //     string += `</div>
        //                   </div>
        //                </div>`
        //     return string;
        //   }
        },
        legend: {
          textStyle: {
            fontFamily: 'Helvetica',
            fontSize: 16,
            fontWeight: 400,
          },
          itemGap: 30
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              alignWithLabel: true
            },
            offset: 10,
            data: [],
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[2]
              }
            },
            nameTextStyle: {
              fontWeight: 500,
              fontSize: 16,
              fontFamily: 'Helvetica',
              color: '#303C54'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: 'Số lượng MM',
            position: 'left',
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[2]
              }
            },
            axisLabel: {
              formatter: '{value}'
            },
            nameTextStyle: {
              fontSize: 16,
              fontFamily: 'Helvetica',
            }
          },
        ],
        series: [
          {
            id: 1,
            type: 'bar',
            data: [],
          },
        ]
      },
      search: {
        division: null,
        year: '',
        type: 1
      },
      optionSearch: 'COMPANY',
      listYear: []
    };
  },
  async created() {
    this.option.xAxis[0]['data'] = labels;
    await this.getDate();
    await this.getData();
  },
  computed: {
    ...mapGetters({
      resourceDivisionStatistics: "project/resourceDivisionStatistics",
      dataMMYear: "project/dataMMYear",
    }),
  },

  methods: {
    async getData() {
      this.option.series[0].data = [];
      const params = {
        year: this.search.year,
        division: this.search.division,
        type: this.search.type
      };
      await this.$store.dispatch("project/getDataMMYear", {params});
      let months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
      let quarters = ['Q1', 'Q2', 'Q3', 'Q4'];
      let dataMMConvert = [];
      let timeCheck = [];
      if (this.search.type === 1) {
        timeCheck = months;
      }
      if (this.search.type === 2) {
        timeCheck = quarters;
      }
      if (this.search.type === 3) {
        timeCheck = this.listYear;
      }
      timeCheck.forEach((time) => {
        let findIndex = this.dataMMYear.findIndex((item) => item.time === time);
        let monthData = {}
        if (findIndex < 0) {
          monthData['time'] = time;
          monthData['effort'] = 0;
          monthData['detail'] = [];
          dataMMConvert.push(monthData);
        } else {
          dataMMConvert.push(this.dataMMYear[findIndex]);
        }
      })
      this.option.series[0].data = dataMMConvert.map(record => {
        return {
          value: record.effort,
          name: record.time,
          detail: record.detail
        };
      })

    },
    getDataSubset(e) {
      let data = {
        activeTab: "tab-list",
        query: {
          status: e.seriesId,
          division: e.data.name,
          footCode: e.data.department_code,
          skill: 0,
          info: ''
        }
      };
      this.$emit('clicked-search-records', data);
    },
    getDate() {
      let currentDate = new Date();
      let currentYear =  moment(currentDate).format("YYYY");
      this.search.year = currentYear;
      let startYear = 2018;
      for (startYear; startYear <= currentYear; startYear ++) {
        this.listYear.push(String(startYear));
      }
    },
    changeYear() {
      if (this.search.type === 3) {
        this.search.type = 1;
        this.option.xAxis[0]['data'] = labels;
      }
      this.getData();
    },
    zoomIn(e) {
      if (e.deltaY > 0 && this.search.type < 3) {
        this.search.type++;
        this.changeData();
      } else if (e.deltaY < 0 && this.search.type > 1) {
        this.search.type--;
        this.changeData();
      }
    },
    changeData() {
      switch (this.search.type) {
        case 1:
          this.option.xAxis[0]['data'] = labels;
          this.getData();
          break;
        case 2:
          this.getQuarterLabel();
          this.getData();
          break;
        case 3:
          this.getYearLabel();
          this.getData();
          break;
      }
    },
    getYearLabel() {
      this.option.xAxis[0]['data'] = [];
      this.listYear.forEach((year) => {
        this.option.xAxis[0].data.push('Năm ' + year);
      })
    },
    getQuarterLabel() {
      this.option.xAxis[0].data =
        ['Quý 1 - ' + this.search.year, 'Quý 2 - ' + this.search.year,'Quý 3 - ' + this.search.year,'Quý 4 - ' + this.search.year];
    },
    resizeWidth() {
      const widthChart = document.getElementById('wrapper-div').offsetWidth;
      if (widthChart >= 1500) {
        this.option.barWidth = 50;
      } else {
        this.option.barWidth = Math.floor(widthChart / 30);

      }
    }
  },
  watch: {
    optionSearch(value) {
      if (value === 'COMPANY') {
        this.search.division = null;
      } else {
        this.search.division = value;
      }
      this.getData();
    }
  },
  mounted: function () {
    window.addEventListener('resize', this.resizeWidth);
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  #project_amount_params {
    display: flex;
    align-items: center;
    #project_amount_selects {
      display: flex;
      height: 72px;
      align-items: center;
      margin-left: 34px;
      border-right: 1px solid #DADADA;
      .project_amount_select {
        display: flex;
        align-items: center;
        margin-right: 12px;
        input {
          margin-right: 10px;
          height: 15px;
          width: 15px;
        }
        label {
          font-family: "Helvetica Neue", sans-serif;
          border: 1px solid #DADADA;
          border-radius: 10px;
          min-width: 100px;
          text-align: left;
          padding-left: 12px;
          height: 41px;
          line-height: 41px;
          font-weight: 400;
          font-size: 14px;
          margin-bottom: 0;
        }
      }
    }
    #year_select {
      margin-left: 14px;
      select {
        width: 151px;
        height: 41px;
        border: 1px solid #DADADA;
        border-radius: 8px;
        background-color: #FFFFFF;
        padding-left: 12px;
      }
    }
  }
  #zoom-chart {
    display: flex;
    justify-content: center;
  }
}
</style>
